// extracted by mini-css-extract-plugin
module.exports = {"overview-report-list__column-hidden":"OverviewReportTable_overview-report-list__column-hidden__1fOT2","ant-table-row":"OverviewReportTable_ant-table-row__1ADZ2"};